import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose, withApollo } from 'react-apollo';
import PrintPreview from 'legacy/src/components/pdf/PrintPreview';
import dayjs from 'dayjs';
import { sendToTelemetry, TLTRY_DEFAULTS } from 'legacy-src/utility/telemetry';
import { connect } from 'react-redux';

const PrintPreviewAction = (props) => {
  const [printPreviewFreshCopy, setPrintPreviewFreshCopy] = useState(false);
  const {
    client,
    subjectData,
    featureFlag,
    associatedResources,
    assessmentId,
    label,
    className,
    role,
    me,
    assesmentType = {},
  } = props;
  const { id: masterSubjectId } = subjectData;
  const { show_attestation_confirmation_dialog: showAttestationFlag } =
    featureFlag;

  const onSendTelemetryEvent = () => {
    const { id: amUserId, pilot } = window.current_user || {};
    const { initId: userId } = me;
    const payload = {
      app: 'assessment_preview',
      event_type: 'action_print_preview',
      params: {
        item_id: assessmentId,
      },
      user: {
        am_user_id: amUserId,
        pilot,
        cb_user_id: userId,
      },
      context: {
        subject_id: masterSubjectId,
        ...assesmentType,
      },
      timestamp: dayjs(),
    };
    sendToTelemetry(Object.assign(payload, TLTRY_DEFAULTS[0]));
  };

  return (
    <PrintPreview
      showIcons
      className={className}
      downloadFreshCopy={printPreviewFreshCopy}
      client={client}
      item={{
        item_id: assessmentId,
        // only PE has associated Resources, real and de-PE-ed ones
        associated_resources: associatedResources,
      }}
      masterSubjectId={masterSubjectId}
      showAttestationFlag={showAttestationFlag}
      onDownload={(downloadFreshCopy) =>
        downloadFreshCopy && setPrintPreviewFreshCopy(false)
      }
      label={label}
      role={role}
      onSendTelemetryEvent={onSendTelemetryEvent}
    />
  );
};

PrintPreviewAction.propTypes = {
  assessmentId: PropTypes.string.isRequired,
  associatedResources: PropTypes.object.isRequired,
  label: PropTypes.any,
  className: PropTypes.string,
  role: PropTypes.string,
};

PrintPreviewAction.defaultProps = {
  label: '',
  className: '',
  role: 'button',
};

const mapStateToProps = (state) => {
  const {
    featureFlag,
    subject,
    userData: { me },
  } = state;
  return {
    subjectData: subject.data,
    featureFlag,
    me,
  };
};

export default compose(
  withApollo,
  connect(mapStateToProps),
)(PrintPreviewAction);
